export const isVar = (text: unknown): text is `var(--${string})` =>
  typeof text === 'string' && text.startsWith('var(--');
